module.exports = __webpack_public_path__ + "img/ring_y_s_null_0.f7e69325.png";